export const getNestedError = (errors: any, fieldName: string) => {
  const path = fieldName.split('.');
  return path.reduce((error, key) => {
    if (key.includes('[')) {
      // Handle array notation, e.g., 'bills[0]'
      const arrayKey = key.split('[')[0];
      const index = parseInt(key.split('[')[1]);
      return error?.[arrayKey]?.[index];
    }
    return error?.[key];
  }, errors);
};
